module.exports = __webpack_public_path__ + "eb7c37bc7d3bb7ace532062f5265ffa6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/hochformat/06.jpg
// module id = 143
// module chunks = 0